export default {
  hero: {
    title: '联系我们',
    subtitle: '让我们携手共创数字化未来'
  },
  
  // 七大服务地区
  serviceRegions: {
    title: '七大服务地区',
    subtitle: '遍布亚太地区的专业服务团队，为您提供本地化支持',
    officeAddress: '服务中心',
    phone: '联系电话',
    email: '电子邮箱',
    workingHours: '工作时间',
    officeHoursNote: '具体响应安排可根据地区与服务等级进行协调',
    noOfficeInfo: '该地区服务中心信息待补充，请先通过邮箱与我们联系。',
    regions: {
      china: {
        name: '中国大陆',
        description: '中国区覆盖上海、北京、深圳等核心城市，可承接跨区域IT服务与本地交付。',
        offices: [
          {
            title: '上海服务中心',
            addressLines: [
              '上海市静安区西藏北路199号',
              '光明地产大厦1003-1室'
            ],
            coordinates: { lat: 31.2411, lng: 121.4754 }
          },
          {
            title: '北京服务中心',
            addressLines: [
              'No. 18, Jingjia Road',
              'Yanqi Town, Huairou District',
              'Beijing, China',
              '北京市怀柔区雁栖镇京加路18号'
            ],
            coordinates: { lat: 40.4018, lng: 116.6766 }
          },
          {
            title: '深圳服务中心',
            addressLines: [
              'Unit 55, Room 1407, Building B, Phase 1',
              'Tian\'an Innovation Technology Plaza',
              'No. 4 Tairan Road, Tian\'an Community, Shatou Street',
              'Futian District, Shenzhen, China',
              '深圳市福田区沙头街道天安社区泰然四路天安创新科技广场一期B座1407-55'
            ],
            coordinates: { lat: 22.5412, lng: 114.0539 }
          }
        ],
        workingHours: '周一至周五 9:00-18:00'
      },
      hongkong: {
        name: '中国香港',
        description: '香港服务中心承担国际业务协同与本地服务支持，可对接跨境IT与商务需求。',
        offices: [
          {
            title: '香港服务中心',
            addressLines: [
              'Room A, 1/F., Arthur Commercial Building,',
              '33 Arthur Road, Yau Ma Tei, Kowloon, Hong Kong',
              '香港九龙油麻地鸦打街33号',
              '雅达商业大厦1楼A室'
            ],
            coordinates: { lat: 22.3070, lng: 114.1714 }
          }
        ],
        workingHours: '周一至周五 9:30-18:30'
      },
      taiwan: {
        name: '台北',
        description: '台湾地区服务能力已覆盖，但服务中心信息仍待客户确认。',
        offices: [],
        workingHours: '周一至周五 9:00-18:00'
      },
      singapore: {
        name: '新加坡',
        description: '新加坡作为东南亚区域支点，可承接区域交付与商务沟通。',
        offices: [
          {
            title: '新加坡服务中心',
            addressLines: [
              '10 ANSON ROAD',
              '#27-18',
              'INTERNATIONAL PLAZA',
              'SINGAPORE (079903)'
            ],
            coordinates: { lat: 1.2752, lng: 103.8453 }
          }
        ],
        workingHours: '周一至周五 9:00-18:00'
      },
      japan: {
        name: '日本',
        description: '日本服务中心面向本地客户与跨国项目，支持日语环境下的本地服务交付。',
        offices: [
          {
            title: '日本服务中心',
            addressLines: [
              '208, 2-9-17 HIGASHITABATA, KITA-KU,',
              'TOKYO 114-0013, JAPAN',
              '東京都北区東田端二丁目9番17-208号'
            ],
            coordinates: { lat: 35.7412, lng: 139.7600 }
          }
        ],
        workingHours: '周一至周五 9:00-18:00'
      },
      korea: {
        name: '首尔',
        description: '韩国地区服务能力已覆盖，但服务中心信息仍待客户确认。',
        offices: [],
        workingHours: '周一至周五 9:00-18:00'
      }
    }
  },
  
  // 即时沟通
  instantCommunication: {
    title: '即时沟通',
    subtitle: '多渠道快速联系，专业团队随时为您服务',
    liveChat: {
      title: '在线客服',
      description: '工作时间内即时响应',
      button: '开始对话',
      hours: '周一至周五 9:00-18:00'
    },
    wechat: {
      title: '企业微信',
      description: '扫码添加企业微信',
      qrcode: '扫描二维码添加',
      qrcodeAlt: '企业微信联系二维码，扫码添加'
    },
    whatsapp: {
      title: 'WhatsApp',
      description: '国际业务快速联系',
      button: '发送消息'
    }
  },
  
  // 咨询表单与商务合作
  formSection: {
    consultation: {
      tab: '业务咨询',
      title: '业务咨询',
      description: '填写咨询表单，我们的专业团队将在24小时内与您联系，为您提供定制化IT解决方案和专案建议。',
      benefits: {
        analysis: '免费需求分析与方案建议',
        demo: '专业团队1对1服务',
        response: '24小时内快速响应',
        privacy: '保护您的隐私信息'
      }
    },
    partnership: {
      tab: '商务合作',
      title: '商务合作',
      description: '欢迎渠道伙伴、技术联盟、解决方案集成商与我们洽谈合作，共同拓展业务市场，实现互利共赢。',
      benefits: {
        channel: '渠道合作伙伴计划',
        tech: '技术联盟与集成',
        solution: '解决方案联合开发',
        support: '全方位支持与培训'
      }
    },
    inquiryType: {
      label: '咨询类型',
      partnershipLabel: '合作类型',
      placeholder: '请选择类型',
      consultation: {
        solution: '解决方案咨询',
        product: '产品功能咨询',
        pricing: '价格与报价',
        demo: '产品演示',
        support: '技术支持'
      },
      partnership: {
        channel: '渠道合作',
        technology: '技术联盟',
        integration: '解决方案集成',
        consulting: '咨询服务合作',
        other: '其他合作'
      }
    },
    region: {
      label: '服务地区',
      placeholder: '请选择服务地区',
      china: '中国大陆',
      hongkong: '中国香港',
      taiwan: '中国台湾',
      singapore: '新加坡',
      japan: '日本',
      korea: '韩国'
    }
  },
  
  info: {
    title: '联系信息',
    address: {
      title: '服务中心地址',
      content: '上海市静安区西藏北路199号光明地产大厦1003-1室'
    },
    phone: {
      title: '联系电话',
      content: '+86 21 8765 4321'
    },
    email: {
      title: '邮箱地址'
    },
    hours: {
      title: '工作时间',
      content: '周一至周五 9:00-18:00'
    }
  },
  
  social: {
    title: '关注我们'
  },
  
  form: {
    title: '发送消息',
    companyName: '公司名称',
    companyNamePlaceholder: '请输入您的公司名称',
    contactName: '联系人姓名',
    contactNamePlaceholder: '请输入您的姓名',
    position: '职位',
    positionPlaceholder: '请输入您的职位',
    email: '邮箱地址',
    emailPlaceholder: '请输入您的邮箱地址',
    phone: '联系电话',
    phonePlaceholder: '请输入您的联系电话',
    industry: '所属行业',
    industryPlaceholder: '请选择您的行业',
    industries: {
      technology: '科技行业',
      finance: '金融行业',
      healthcare: '医疗健康',
      education: '教育行业',
      manufacturing: '制造业',
      retail: '零售业',
      other: '其他'
    },
    companySize: '公司规模',
    companySizePlaceholder: '请选择公司规模',
    employees: '人',
    interestedServices: '感兴趣的服务',
    serviceOptions: {
      ticketSystem: '智能工单系统',
      aiSolutions: 'AI解决方案',
      dataAnalytics: '数据分析',
      consulting: 'IT咨询'
    },
    budget: '项目预算',
    budgetPlaceholder: '请选择预算范围',
    budgetOptions: {
      under50k: '5万元以下',
      range50k100k: '5万至10万元',
      range100k500k: '10万至50万元',
      range500k1m: '50万至100万元',
      over1m: '100万元以上'
    },
    message: '项目描述',
    messagePlaceholder: '请详细描述您的项目需求和期望',
    submit: '提交咨询',
    submitting: '提交中'
  },
  
  success: {
    title: '提交成功',
    message: '我们已收到您的咨询，将在24小时内与您联系。',
    close: '确定'
  },
  
  regions: {
    title: '服务地区',
    selectRegion: '选择地区',
    allRegions: '所有地区'
  }
}
